export default "__VITE_ASSET__903a55b6__"